module.exports = __webpack_public_path__ + "static/img/banner-textnew2.f839c60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner-textnew2.png
// module id = /SLb
// module chunks = 1